import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/subscribe", { email });
      toast.success("Subscribed. Talk soon.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="border-t border-border/60 mt-24 bg-secondary/40">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif text-2xl font-semibold tracking-[0.15em]">
            MONEYSSANCE
          </div>
          <p className="mt-4 text-sm text-foreground/60 max-w-xs leading-relaxed italic">
            Miscellaneous thoughts on money and related fields.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-foreground/50 mb-4">
            Sitemap
          </div>
          <ul className="text-sm">
            <li>
              <Link to="/thoughts" data-testid="footer-link-thoughts" className="block py-2.5 md:py-1 hover:text-primary transition-colors">
                Thoughts
              </Link>
            </li>
            <li>
              <Link to="/blog" data-testid="footer-link-journal" className="block py-2.5 md:py-1 hover:text-primary transition-colors">
                Journal
              </Link>
            </li>
            <li>
              <Link to="/tools" data-testid="footer-link-tools" className="block py-2.5 md:py-1 hover:text-primary transition-colors">
                Tools
              </Link>
            </li>
            <li>
              <Link to="/about" data-testid="footer-link-about" className="block py-2.5 md:py-1 hover:text-primary transition-colors">
                About
              </Link>
            </li>
            <li>
              <Link to="/login" data-testid="footer-link-signin" className="block py-2.5 md:py-1 hover:text-primary transition-colors">
                Sign in
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-foreground/50 mb-4">
            Get the next entry
          </div>
          <form onSubmit={handleSubscribe} className="flex gap-2" data-testid="newsletter-form">
            <input
              type="email"
              required
              placeholder="you@somewhere.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="newsletter-email-input"
              className="flex-1 bg-background border border-border rounded-full px-4 py-2 text-sm focus:outline-none focus-visible:ring-1 focus-visible:ring-primary"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="newsletter-submit"
              className="rounded-full bg-primary text-primary-foreground text-sm px-5 py-2 hover:bg-primary/90 transition-colors disabled:opacity-60"
            >
              Join
            </button>
          </form>
          <p className="mt-3 text-xs text-foreground/50">
            One email when I publish. No noise.
          </p>
        </div>
      </div>
      <div className="border-t border-border/60 py-6 text-center text-xs text-foreground/50">
        © {new Date().getFullYear()} Moneyssance. Built to be owned.
      </div>
    </footer>
  );
}
